// Stub for Node.js modules that shouldn't run in the browser
// This file is used to trick the build into thinking Node APIs exist, but they do nothing in the browser.

// Types for the stubbed exports
export type SpawnFunction = (...args: unknown[]) => void;
export type ExecFunction = (...args: unknown[]) => void;
export type ForkFunction = (...args: unknown[]) => void;

export default {};
export const spawn: SpawnFunction = () => {};
export const exec: ExecFunction = () => {};
export const fork: ForkFunction = () => {};
export const Worker = class Worker {};
export const isMainThread = true;
export const parentPort: null = null;
export const workerData: null = null;
